














import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class QuestionFormTypes extends Vue {
  @Prop({ type: String, default: "" }) formType!: string;

  get syncedFormType() {
    return this.formType;
  }
  set syncedFormType(v) {
    this.$emit("update:form-type", v);
  }

  formTypes = [
    {
      text: "Input",
      value: "textinput"
    },
    {
      text: "Textarea",
      value: "textarea"
    },
    {
      text: "Number Input",
      value: "numberinput"
    },
    // {
    //   text: "Switch",
    //   value: "switch",
    // },
    {
      text: "Checkbox",
      value: "checkbox"
    },
    {
      text: "Radio Button",
      value: "radiobutton"
    },
    {
      text: "Dropdown Single",
      value: "dropdown_single"
    },
    {
      text: "Dropdown Multiple",
      value: "dropdown_multiple"
    },
    {
      text: "Range Slider",
      value: "rangeslider"
    },
    {
      text: "Date Picker",
      value: "datepicker"
    },
    {
      text: "Datetime Picker",
      value: "datetimepicker"
    },
    {
      text: "Time Picker",
      value: "timepicker"
    },
    {
      text: "Body Parts",
      value: "body_parts"
    },
    {
      text: "Country",
      value: "country"
    },
    {
      text: "State",
      value: "state"
    }
  ];
}
